var MOBILE_SCREEN_SIZE = 600;
var TABLET_SCREEN_SIZE = 1050;
var DIALOG_SCREEN_SIZE = 625;
var SMALL_TABLET_SCREEN_SIZE = 768;
var DESKTOP_SCREEN_SIZE = 1680;
var DESKTOP_HORIZONTAL_PADDING = 140;
var MOBILE_HORIZONTAL_PADDING = 20;
var TABLET_HORIZONTAL_PADDING = 40;
var WIDGET_SPACE = 50;
var WIDGET_SPACE_HALF = WIDGET_SPACE / 2;
var WIDGET_MEDIA_BORDER_RADIUS = 5; // image / videp
var DEFAULT_LINK_ID = '#';
var BRANDCLUB_RETAILERS;
(function (BRANDCLUB_RETAILERS) {
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Amazon"] = 1] = "Amazon";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Walmart"] = 2] = "Walmart";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["BestBuy"] = 3] = "BestBuy";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Target"] = 4] = "Target";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Costco"] = 9] = "Costco";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Chewy"] = 18] = "Chewy";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Kroger"] = 48] = "Kroger";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Sephora"] = 50] = "Sephora";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Safeway"] = 92] = "Safeway";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Qfc"] = 93] = "Qfc";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Albertsons"] = 94] = "Albertsons";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["FredMeyer"] = 127] = "FredMeyer";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["Ralphs"] = 128] = "Ralphs";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["KrogerFamily"] = 129] = "KrogerFamily";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["AlbertsonsFamily"] = 170] = "AlbertsonsFamily";
    BRANDCLUB_RETAILERS[BRANDCLUB_RETAILERS["HomeDepot"] = 6] = "HomeDepot";
})(BRANDCLUB_RETAILERS || (BRANDCLUB_RETAILERS = {}));
var WIDGET_PAIR_PRODUCT_PADDING = 50;
var PLACEHOLDER_GREEN_IMAGE = {
    '1X1': 'https://media.brandclub.com/cms/widgets/Placeholder_Green_Image_1x1.png',
};
var BRANDCLUB_BRAND_ID = 50000;
var UNIVERSAL_STORE_SITE = 'https://brandclub.com';

export { BRANDCLUB_BRAND_ID, BRANDCLUB_RETAILERS, DEFAULT_LINK_ID, DESKTOP_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DIALOG_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, PLACEHOLDER_GREEN_IMAGE, SMALL_TABLET_SCREEN_SIZE, TABLET_HORIZONTAL_PADDING, TABLET_SCREEN_SIZE, UNIVERSAL_STORE_SITE, WIDGET_MEDIA_BORDER_RADIUS, WIDGET_PAIR_PRODUCT_PADDING, WIDGET_SPACE, WIDGET_SPACE_HALF };
//# sourceMappingURL=Constants.js.map
